import React from 'react';
import cx from 'classnames';

import { TickCircleIcon } from '@motorway/mw-highway-code';

import styles from './HeroImageCard.scss';

export const HeroImageCard = () => {
  const ImageDetails = [
    [{ title: 'Mileage', value: '47,890 miles' }, { title: 'MOT valid for', value: '85 days' }],
    [{ title: 'Tax valid for', value: '85 days' }],
  ];

  const details = ImageDetails[0];

  return (<div className={cx(styles.component, styles.card)}>
    <div className={styles.title}>
      <TickCircleIcon data-thc-icon size="medium" />
      <span>{'Pass'}</span>
    </div>
    {
      details.map(({ title, value }) => (
        <div key={title} className={styles.details}>
          <b>{title}</b>
          <span>{value}</span>
        </div>
      ))
    }
  </div>);
};
